import { Component, OnInit, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UtilisateurSaveDto } from '../../dto/utilisateur-save-dto';
import { UtilisateursService } from '../../service/utilisateurs.service';
import { UtilisateurDto } from '../../dto/utilisateur-dto';

@Component({
  selector: 'app-edit-user-modal',
  templateUrl: './edit-user-modal.component.html',
  styleUrls: ['./edit-user-modal.component.scss']
})
export class EditUserModalComponent implements OnInit {

  @Input() utilisateur!: UtilisateurDto;
  adminControl: FormControl;

  formModalIsSubmitting: boolean = false;

  constructor(
    private utilisateurService: UtilisateursService,
    private toastr: ToastrService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.adminControl = new FormControl(this.utilisateur.admin, [Validators.required]);
  }

  onSubmit(): void {
      this.formModalIsSubmitting = true;
  
      const newUser: UtilisateurSaveDto = {
        nom: this.utilisateur.nom,
        prenom: this.utilisateur.prenom,
        email: this.utilisateur.email, 
        admin: this.adminControl.value
      };
  
      this.utilisateurService.editUtilisateur(newUser, this.utilisateur.id).subscribe({
        next: () => {
          this.toastr.success('Utilisateur modifié avec succès');
          this.formModalIsSubmitting = false;
          this.activeModal.close('edited'); 
        },
        error: () => {
          this.toastr.error("Erreur lors de l'édition de l'utilisateur");
          this.formModalIsSubmitting = false;
          this.activeModal.dismiss();
        }
      });
  }
  

  fermerModal(): void {
    this.activeModal.dismiss();
  }
}